import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxDrpOptions, PresetItem, Range } from 'ngx-mat-daterange-picker';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { PaymentService } from '../services/payment/payment.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Refund } from '../models/refund';
import { UserService } from '../services/user/user.service';
import { element } from 'protractor';
import { SharedService } from '../services/shared/shared.service';

declare var $: any;

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.css']
})
export class TransactionHistoryComponent implements OnInit {

  @ViewChild(ModalDirective, { static: true }) modal: ModalDirective;
  @ViewChild("refundModal", { static: true }) refundModal: ModalDirective;
  @ViewChild("refundHistoryModal", { static: true }) refundHistoryModal: ModalDirective;

  customDateFormat = "";
  subscriptionsToRefund: any[] = []; refundComments: string = null; refundHistory: any[] = [];
  selectedPackageForRefund: any = {}; amounttoRefund: number = 0; selectedSubscriptionsToRefund: number = 0;
  transactionsBackup: any[] = []; selectedSubscribedPackage: any; packages: any[] = [];
  range: Range = { fromDate: new Date(), toDate: new Date() };
  options: NgxDrpOptions; locationId = null; billItems = []; userSearch: string = ""; transactionIdSearch: string = "";
  presets: Array<PresetItem> = []; accountId = null; orgId = null;
  accounts: Account[] = []; transactionHistory: any[] = []; screeningCenters: any[] = [];
  allaccounts: any[] = [];
  applications: any[]; applicationId: string; spectacleVendorProviders: any[] = []; selectedSpectacleVendorProviderId: string;
  selectedPaymentFilter: any = "all";
  totalRecords: any = 0;
  transactionIdFilterSubscribe = null; userNameFilterSubscribe = null;
  recordsPerPage = 10;

  filteredTime = {
    startDate: new Date(),
    endDate: new Date()
  }

  constructor(public accountService: AccountService, public foruscareService: ForuscareService, public userService: UserService,
    public paymentService: PaymentService,
    private sharedService: SharedService) { }

  getAccounts() {
    this.allaccounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.allaccounts = response.data;
            this.accounts = response.data;
            // this.getTransactionHistory();
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  updateRefundAmount() {
    if (this.selectedPackageForRefund != null && this.selectedPackageForRefund.subsriptionPkg != null && this.selectedPackageForRefund.subsriptionPkg.length > 0) {
      var selectedPackages = this.selectedPackageForRefund.subsriptionPkg.filter(ob => ob.isReturn == true);
      if (selectedPackages != null && selectedPackages.length > 0) {
        this.selectedSubscriptionsToRefund = selectedPackages.length;
        this.amounttoRefund = selectedPackages.reduce(function (prev, cur) {
          return prev + (cur.price * Number(cur.quantity));
        }, 0);
      }
      else {
        this.amounttoRefund = 0;
        this.selectedSubscriptionsToRefund = 0;
      }
    }
  }

  ngOnInit() {
    this.applications = [{ id: "DHP", name: "DHP" }, { id: "EYE_CONNECT", name: "Eye Connect" }, { id: "SPECTACLE", name: "Spectacle" }, { id: "APPOINTMENT_BOOKING", name: "Appointment Booking" }, { id: "FH-PAYMENT", name: "Forus Vision" }]
    this.applicationId = "DHP";
    //this.getSpectacleVendorProviders();
    this.customDateFormat = this.foruscareService.getDateFormat();
    const today = new Date();
    const fromMin = new Date(today.getFullYear(), today.getMonth() - 2, 1);
    const fromMax = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const toMin = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const toMax = new Date(today.getFullYear(), today.getMonth() + 2, 0);

    this.setupPresets();
    this.options = {
      presets: this.presets,
      //format: 'mediumDate',
      format: this.foruscareService.getDateFormat().split(" ")[0],
      range: { fromDate: today, toDate: today },
      applyLabel: "Submit",
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: false,
        hasBackdrop: false
      }
    };
    this.getAccounts();
    $('#all').css("border-bottom", "2px solid rgb(53,191,224");
  }

  hidePackageDetailsWindow() {
    this.modal.hide();
  }

  initiateRefund(transaction) {
    this.userService.getIncentivePlanByUserId(transaction.userId)
      .subscribe(response => {
        if (response != null) {
          this.foruscareService.showNotification("Refund not allowed for incentive transactions", "danger");
        }
        else {
          this.refundComments = null; this.amounttoRefund = 0; this.selectedSubscriptionsToRefund = 0;
          this.selectedPackageForRefund = transaction;
          if (this.selectedPackageForRefund.subsriptionPkg != null && this.selectedPackageForRefund.subsriptionPkg.length > 0) {
            this.selectedPackageForRefund.subsriptionPkg.forEach(packageInfo => {
              packageInfo.isReturn = false;
            });
            this.refundModal.show();
          }
        }
      })
  }

  refundAmount() {
    this.subscriptionsToRefund = [];
    if (this.refundComments == null || this.refundComments.trim().length == 0) {
      this.foruscareService.showNotification("Please enter refund comments.", "warning");
      return;
    }
    if (this.selectedPackageForRefund != null && this.selectedPackageForRefund.subsriptionPkg != null && this.selectedPackageForRefund.subsriptionPkg.length > 0) {
      var selectedPackages = this.selectedPackageForRefund.subsriptionPkg.filter(ob => ob.isReturn == true);
      let refundDetails = new Refund();
      if (selectedPackages != null && selectedPackages.length > 0) {
        refundDetails.accountId = selectedPackages[0].accountId.toString();
        refundDetails.orgId = selectedPackages[0].orgId;
        refundDetails.transactionId = selectedPackages[0].transactionId;
        refundDetails.comments = this.refundComments;
        selectedPackages.forEach(packageInfo => {
          this.subscriptionsToRefund.push(packageInfo.id);
        });

        if (this.subscriptionsToRefund != null && this.subscriptionsToRefund.length > 0) {
          refundDetails.subscriptions = this.subscriptionsToRefund;
          this.paymentService.intiateRefund(refundDetails)
            .subscribe(response => {
              if (response.errorCode == 200 && response.data != null) {
                this.foruscareService.showNotification("Refund initiated successfully", "success");
                this.refundModal.hide();
                this.getTransactions();
              }
              else {
                this.foruscareService.showNotification("Something went wrong", "danger");
              }
            })
        }
      }
    }
  }

  hideRefundHistoryWindow() {
    this.refundHistoryModal.hide();
  }

  getRefundHistoryByTransactionId(transactionId) {
    if (transactionId != null) {
      this.refundHistory = [];
      this.paymentService.getRefundHistoryByTransactionId(transactionId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.data != null) {
            this.refundHistory = response.data;
            this.refundHistoryModal.show();
          }
          else {
            this.foruscareService.showNotification("Something went wrong", "danger");
          }
        })
    }
  }

  hideRefundDetailsWindow() {
    this.refundModal.hide();
  }


  populateTransactionHistory(data) {
    this.transactionHistory = [];
    data.forEach(transaction => {
      if (transaction.subsriptionPkg != null && transaction.subsriptionPkg.length > 0) {
        var refundedTransactions = transaction.subsriptionPkg.filter(function (s) {
          return (s.currentStatus.toUpperCase().indexOf("REFUND")) >= 0;
        });
        transaction.refundMode = null;
        transaction.eligibleForRefundAction = false;
        if (refundedTransactions != null && refundedTransactions.length > 0) {
          transaction.refundMode = "PARTIAL";
        }
        if (refundedTransactions != null && refundedTransactions.length == transaction.subsriptionPkg.length) {
          transaction.refundMode = "FULL";
        }

        var yetToUseSubscriptions = transaction.subsriptionPkg.filter(function (s) {
          return (s.currentStatus.toUpperCase().indexOf("PACKAGE_SUBSCRIBED")) >= 0;
        });
        if (yetToUseSubscriptions != null && yetToUseSubscriptions.length > 0) {
          transaction.eligibleForRefundAction = true;
        }
        if (transaction?.rechargeDoneByUserRole != null) {
          var role = this.getDisplayRole(transaction.rechargeDoneByUserRole);
          transaction.rechargeDoneByUserRole = role;
        }
      }
      this.transactionHistory.push(transaction);
    });
    this.transactionsBackup = data;
  }

  filterTransactionByTransactionId(event) {
    this.userSearch = null;
    this.resetToAll();
    this.userSearch = null;
    if (this.transactionIdSearch == null || this.transactionIdSearch.trim().length < 3) {
      if (this.transactionIdSearch.trim().length == 0) {
        this.getTransactionHistory(0);
      }
      return;
    }
    this.transactionIdSearch = this.transactionIdSearch.trim();
    if (this.transactionIdFilterSubscribe != null) {
      this.transactionIdFilterSubscribe.unsubscribe();
    }
    this.transactionsBackup = [];
    this.transactionHistory = [];
    switch (this.applicationId) {
      case "DHP":
        this.transactionIdFilterSubscribe = this.paymentService.getTransactionHistoryByTransactionId(this.transactionIdSearch, null, null)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp == null || t.sourceapp.toLowerCase() == 'dhp') });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(dhpTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          })
        break;
      case "FH-PAYMENT":
        this.transactionIdFilterSubscribe = this.paymentService.getTransactionHistoryByTransactionId(this.transactionIdSearch, null, null)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp == null || t.sourceapp == 'FH-PAYMENT') });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(dhpTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          })
        break;
      case "EYE_CONNECT":
        this.transactionIdFilterSubscribe = this.paymentService.getTransactionHistoryByTransactionId(this.transactionIdSearch, null, null)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp && t.sourceapp.toLowerCase() == 'eye_connect') });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(dhpTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          })
        break;
      case "SPECTACLE":
        let request = {
          startDate: this.foruscareService.getDateForServerAPI(this.range.fromDate),
          endDate: this.foruscareService.getDateForServerAPI(this.range.toDate),
          providerId: this.selectedSpectacleVendorProviderId,
          transactionId: (this.transactionIdSearch != null && this.transactionIdSearch.length == 0) ? null : this.transactionIdSearch,
          initiatedBy: (this.userSearch != null && this.userSearch.length == 0) ? null : this.userSearch,
          userId: Number(this.sharedService.getUserInfo().userId),
          role: "ROLE_SUPER_ADMIN"
        }
        this.transactionIdFilterSubscribe = this.paymentService.getSpectacleTransactionHistory(request, this.selectedPaymentFilter, 0, this.recordsPerPage)
          .subscribe(response => {
            if (response.status == 200 && response.data != null) {
              let transactionList = [];
              if (response.data.length > 0) {
                response.data.forEach(element => {
                  let obj: any = {};
                  obj.price = element.amount;
                  obj.amountPaid = element.amount;
                  switch (element.transactionStatus) {
                    case "SUCCESS": obj.paymentStatus = "success"; break;
                    case "PAYMENT_FAILED": obj.paymentStatus = "failure"; break;
                    case "PAYMENT_INITIATED": obj.paymentStatus = "INITIATED"; break;
                  }
                  obj.transactionId = element.transactionId;
                  obj.mercantile = element.mercantile;
                  obj.paymentTime = element.created;
                  obj.createdBy = element.initiatedBy;
                  obj.isOffline = (element.paymentType && element.paymentType.toLowerCase() == 'onlinetransaction') ? false : true;
                  transactionList.push(obj);
                });
                this.totalRecords = response.totalCounts;
                this.populateTransactionHistory(transactionList);
              }
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          });
        break;
      case "APPOINTMENT_BOOKING":
        this.transactionIdFilterSubscribe = this.paymentService.getTransactionHistoryByTransactionId(this.transactionIdSearch, null, null)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let appointmentTransactions = [];
                  response.data.forEach(element => {
                    if (element.sourceapp == 'FH_DHP_APPOINTMENT') {
                      element.price = element.amountPaid;
                      if (element.paymentStatus == 'PAYMENT_INITIATED') {
                        element.paymentStatus = 'INITIATED';
                      }
                      appointmentTransactions.push(element);
                    }
                  });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(appointmentTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          });
        break;
    }
  }

  filterTransactionByUserName(nextoffset) {
    this.resetToAll();
    this.transactionIdSearch = null;
    if (this.userSearch == null || this.userSearch.trim().length < 3) {
      if (this.userSearch.trim().length == 0) {
        this.getTransactionHistory(0);
      }
      return;
    }
    this.userSearch = this.userSearch.trim();
    if (this.userNameFilterSubscribe != null) {
      this.userNameFilterSubscribe.unsubscribe();
    }
    this.transactionsBackup = [];
    this.transactionHistory = [];
    switch (this.applicationId) {
      case "DHP":
        this.userNameFilterSubscribe = this.paymentService.getTransactionHistoryByUserNameOrEmail(this.userSearch, null, null, nextoffset, this.recordsPerPage)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp == null || t.sourceapp.toLowerCase() == 'dhp') });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(dhpTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          })
        break;
      case "FH-PAYMENT":
        this.userNameFilterSubscribe = this.paymentService.getTransactionHistoryByUserNameOrEmail(this.userSearch, null, null, nextoffset, this.recordsPerPage)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp == null || t.sourceapp == 'FH-PAYMENT') });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(dhpTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          })
        break;
      case "EYE_CONNECT":
        this.userNameFilterSubscribe = this.paymentService.getTransactionHistoryByUserNameOrEmail(this.userSearch, null, null, nextoffset, this.recordsPerPage)
          .subscribe(response => {
            if (response.errorCode == 200) {
              if (response.data != null) {
                if (response.data.length > 0) {
                  let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp && t.sourceapp.toLowerCase() == 'eye_connect') });
                  this.totalRecords = response.totalCount;
                  this.populateTransactionHistory(dhpTransactions);
                }
              }
            }
            else {
              this.foruscareService.showNotification("Something went wrong", "danger");
            }
          })
        break;
      case "SPECTACLE":
        let request = {
          startDate: this.foruscareService.getDateForServerAPI(this.range.fromDate),
          endDate: this.foruscareService.getDateForServerAPI(this.range.toDate),
          providerId: this.selectedSpectacleVendorProviderId,
          transactionId: (this.transactionIdSearch != null && this.transactionIdSearch.length == 0) ? null : this.transactionIdSearch,
          initiatedBy: (this.userSearch != null && this.userSearch.length == 0) ? null : this.userSearch,
          userId: Number(this.sharedService.getUserInfo().userId),
          role: "ROLE_SUPER_ADMIN"
        }
        this.userNameFilterSubscribe = this.paymentService.getSpectacleTransactionHistory(request, this.selectedPaymentFilter, 0, this.recordsPerPage)
          .subscribe(response => {
            if (response.status == 200 && response.data != null) {
              let transactionList = [];
              if (response.data.length > 0) {
                response.data.forEach(element => {
                  let obj: any = {};
                  obj.price = element.amount;
                  obj.amountPaid = element.amount;
                  switch (element.transactionStatus) {
                    case "SUCCESS": obj.paymentStatus = "success"; break;
                    case "PAYMENT_FAILED": obj.paymentStatus = "failure"; break;
                    case "PAYMENT_INITIATED": obj.paymentStatus = "INITIATED"; break;
                  }
                  obj.transactionId = element.transactionId;
                  obj.mercantile = element.mercantile;
                  obj.paymentTime = element.created;
                  obj.createdBy = element.initiatedBy;
                  obj.isOffline = (element.paymentType && element.paymentType.toLowerCase() == 'onlinetransaction') ? false : true;
                  transactionList.push(obj);
                });
                this.totalRecords = response.totalCounts;
                this.populateTransactionHistory(transactionList);
              }
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          });
        break;
    }
  }

  getPackageDetails() {
    this.paymentService.getPackageDetails()
      .subscribe(response => {
        if (response.errorCode == 200 && response.data != null) {
          this.packages = response.data;
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }

  getScreeningCentersByAccountID() {
    this.userSearch = null;
    this.getTransactions();
    if (this.accountId != null && this.accountId > 0) {
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.screeningCenters = response.data;
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }


  showSubscribedPackageDetailsWindow = function (selectedSubscribedPackage) {
    this.selectedSubscribedPackage = selectedSubscribedPackage;
    this.packages.forEach(element => {
      if (element.id == selectedSubscribedPackage.pkgId) {
        this.tempPackage = element;
      }
    });
    this.modal.show();
  }

  convertUTCToLocal(utcString) {
    return this.foruscareService.convertUTCtoLocal(utcString);
  }

  filterByTransactionStatus = function (status) {
    $('#all').css("border-bottom", "none"); $('#success').css("border-bottom", "none");
    $('#failure').css("border-bottom", "none"); $('#initiated').css("border-bottom", "none"); $('#refunded').css("border-bottom", "none");
    // $scope.pagination.currentPage = 1;
    this.selectedPaymentFilter = status;
    if (status == "all") {
      $('#all').css("border-bottom", "2px solid rgb(53,191,224");
      this.getTransactionHistory(0);
    }
    else if (status == "successful") {
      $('#success').css("border-bottom", "2px solid rgb(53,191,224");
      this.getTransactionHistory(0);
    }
    else if (status == "failed") {
      $('#failure').css("border-bottom", "2px solid rgb(53,191,224");
      this.getTransactionHistory(0);
    }
    else if (status == "initiated") {
      $('#initiated').css("border-bottom", "2px solid rgb(53,191,224");
      this.getTransactionHistory(0);
    }
    else if (status == "refunded") {
      $('#refunded').css("border-bottom", "2px solid rgb(53,191,224");
      this.getTransactionHistory(0);
    }
  }

  filterTransactions = function (status) {
    $('#all').css("border-bottom", "none"); $('#success').css("border-bottom", "none");
    $('#failure').css("border-bottom", "none"); $('#initiated').css("border-bottom", "none"); $('#refunded').css("border-bottom", "none");
    if (status == "all") {
      $('#all').css("border-bottom", "2px solid rgb(53,191,224");
      this.transactionHistory = this.transactionsBackup;
    }
    else if (status == "success") {
      $('#success').css("border-bottom", "2px solid rgb(53,191,224");
      var successfulTransactions = this.transactionsBackup.filter(function (t) {
        return t.paymentStatus == "success";
      });
      this.transactionHistory = successfulTransactions;
    }
    else if (status == "failure") {
      $('#failure').css("border-bottom", "2px solid rgb(53,191,224");
      var failedTransactions = this.transactionsBackup.filter(function (t) {
        return t.paymentStatus == "failure";
      });
      this.transactionHistory = failedTransactions;
    }
    else if (status == "initiated") {
      $('#initiated').css("border-bottom", "2px solid rgb(53,191,224");
      var failedTransactions = this.transactionsBackup.filter(function (t) {
        return t.paymentStatus == "INITIATED";
      });
      this.transactionHistory = failedTransactions;
    }
    else if (status == "refunded") {
      $('#refunded').css("border-bottom", "2px solid rgb(53,191,224");
      var refundedTransactions = this.transactionsBackup.filter(function (t) {
        return t.refundMode != null;
      });
      this.transactionHistory = refundedTransactions;
    }
  }

  getTransactionHistory(nextoffset: any) {
    //this.filterTransactions("all");
    if (this.range.fromDate != null && this.range.toDate != null) {
      this.transactionHistory = [];
      this.transactionsBackup = [];
      switch (this.applicationId) {
        case "DHP":
          this.paymentService.getPaymentTransactionHistoryDateRangeAndOrg(this.accountId, this.orgId, this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate), "DHP", this.selectedPaymentFilter, nextoffset, this.recordsPerPage)
            .subscribe(response => {
              if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
                if (response.data != null) {
                  if (response.data.length > 0) {
                    let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp == null || t.sourceapp.toLowerCase() == 'dhp') });
                    this.totalRecords = response.totalCount;
                    this.populateTransactionHistory(dhpTransactions);
                  }
                }
              }
              else {
                this.foruscareService.showNotification(response.message, "danger");
              }
            });
          break;
        case "FH-PAYMENT":
          this.paymentService.getPaymentTransactionHistoryDateRangeAndOrg(
            this.accountId,
            this.orgId,
            this.foruscareService.getDateForServerAPI(this.range.fromDate),
            this.foruscareService.getDateForServerAPI(this.range.toDate),
            "FH-PAYMENT",
            this.selectedPaymentFilter,
            nextoffset,
            this.recordsPerPage
          ).subscribe(response => {
            if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
              if (response.data != null && response.data.length > 0) {
                let fvTransactions = response.data.filter(t => t.sourceapp == null || t.sourceapp === 'FH-PAYMENT');
                this.totalRecords = response.totalCount;
                this.populateTransactionHistory(fvTransactions);
              }
            } else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          });
          break;
        case "EYE_CONNECT":
          this.paymentService.getPaymentTransactionHistoryDateRangeAndOrg(this.accountId, this.orgId, this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate), "EYE_CONNECT", this.selectedPaymentFilter, nextoffset, this.recordsPerPage)
            .subscribe(response => {
              if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
                if (response.data != null) {
                  if (response.data.length > 0) {
                    let dhpTransactions = response.data.filter(function (t) { return (t.sourceapp && t.sourceapp.toLowerCase() == 'eye_connect') });
                    this.totalRecords = response.totalCount;
                    this.populateTransactionHistory(dhpTransactions);
                  }
                }
              }
              else {
                this.foruscareService.showNotification(response.message, "danger");
              }
            });
          break;
        case "SPECTACLE":
          let request = {
            startDate: this.foruscareService.getDateForServerAPI(this.range.fromDate),
            endDate: this.foruscareService.getDateForServerAPI(this.range.toDate),
            providerId: this.selectedSpectacleVendorProviderId,
            transactionId: (this.transactionIdSearch != null && this.transactionIdSearch.length == 0) ? null : this.transactionIdSearch,
            initiatedBy: (this.userSearch != null && this.userSearch.length == 0) ? null : this.userSearch,
            userId: Number(this.sharedService.getUserInfo().userId),
            role: "ROLE_SUPER_ADMIN"
          }
          this.paymentService.getSpectacleTransactionHistory(request, this.selectedPaymentFilter, nextoffset, this.recordsPerPage)
            .subscribe(response => {
              if (response.status == 200 && response.data != null) {
                let transactionList = [];
                if (response.data.length > 0) {
                  response.data.forEach(element => {
                    let obj: any = {};
                    obj.price = element.amount;
                    obj.amountPaid = element.amount;
                    switch (element.transactionStatus) {
                      case "SUCCESS": obj.paymentStatus = "success"; break;
                      case "PAYMENT_FAILED": obj.paymentStatus = "failure"; break;
                      case "PAYMENT_INITIATED": obj.paymentStatus = "INITIATED"; break;
                    }
                    obj.transactionId = element.transactionId;
                    obj.mercantile = element.mercantile;
                    obj.paymentTime = element.created;
                    obj.createdBy = element.initiatedBy;
                    obj.isOffline = (element.paymentType && element.paymentType.toLowerCase() == 'onlinetransaction') ? false : true;
                    transactionList.push(obj);
                  });
                  this.totalRecords = response.totalCounts;
                  this.populateTransactionHistory(transactionList);
                }
              }
              else {
                this.foruscareService.showNotification(response.message, "danger");
              }
            });
          break;
        case "APPOINTMENT_BOOKING":
          this.paymentService.getPaymentTransactionHistoryDateRangeAndOrg(this.accountId, this.orgId, this.foruscareService.getDateForServerAPI(this.range.fromDate), this.foruscareService.getDateForServerAPI(this.range.toDate), "FH_DHP_APPOINTMENT", this.selectedPaymentFilter, nextoffset, this.recordsPerPage)
            .subscribe(response => {
              if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
                if (response.data != null) {
                  if (response.data.length > 0) {
                    let appointmentTransactions = [];
                    response.data.forEach(element => {
                      if (element.sourceapp == 'FH_DHP_APPOINTMENT') {
                        element.price = element.amountPaid;
                        if (element.paymentStatus == 'PAYMENT_INITIATED') {
                          element.paymentStatus = 'INITIATED';
                        }
                        appointmentTransactions.push(element);
                      }
                    });
                    this.totalRecords = response.totalCount;
                    this.populateTransactionHistory(appointmentTransactions);
                  }
                }
              }
              else {
                this.foruscareService.showNotification(response.message, "danger");
              }
            });
          break;
      }

    }
    else {
      this.foruscareService.showNotification("Please select valid date range", "danger");
    }
  }

  getTransactions() {
    this.userSearch = null;
    this.resetToAll();
    this.getTransactionHistory(0);
    this.filteredTime = {
      startDate: this.range.fromDate,
      endDate: this.range.toDate
    }
  }

  // handler function that receives the updated date range object
  updateRange(range: Range) {
    this.range = range;
    this.userSearch = null;
    this.resetToAll();
    this.getTransactionHistory(0);
  }

  setupPresets() {
    const backDate = (numOfDays) => {
      const today = new Date();
      return new Date(today.setDate(today.getDate() - numOfDays));
    }

    const today = new Date();
    const yesterday = backDate(1);
    const minus7 = backDate(7)
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

    this.presets = [
      { presetLabel: "Yesterday", range: { fromDate: yesterday, toDate: yesterday } },
      { presetLabel: "Last 7 Days", range: { fromDate: minus7, toDate: today } },
      { presetLabel: "Last 30 Days", range: { fromDate: minus30, toDate: today } },
      { presetLabel: "This Month", range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { presetLabel: "Last Month", range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
    ]
  }

  syncPaymentStatus(paymentRecord) {
    //$rootScope.showLoading($translate.instant("UPDATING_STATUS"));
    let application;
    switch (this.applicationId) {
      case "DHP": application = "DHP"; break;
      case "EYE_CONNECT": application = "EYE_CONNECT"; break;
      case "SPECTACLE": application = "FH_SPECTACLE"; break;
      case "APPOINTMENT_BOOKING": application = "FH_DHP_APPOINTMENT"; break;
      case "FH-PAYMENT": application = "FH-PAYMENT"; break;
    }
    let obj = {
      orderId: paymentRecord.transactionId,
      application: application,
      token: this.sharedService.getAccessToken()
    }
    this.paymentService.updatePaymentStatusByOrderId(obj)
      .subscribe(response => {
        //$rootScope.hideLoading();
        if (response.errorCode == 200) {
          if (this.applicationId == "DHP" && response.data != null && (response.data.paymentStatus.toLowerCase() == 'success' || response.data.paymentStatus.toLowerCase() == 'failure')) {
            for (let i = 0; i < this.transactionHistory.length; i++) {
              if (this.transactionHistory[i].transactionId == paymentRecord.transactionId) {
                this.transactionHistory[i].paymentStatus = response.data.paymentStatus;
                if (this.transactionHistory[i].subsriptionPkg != null && this.transactionHistory[i].subsriptionPkg.length > 0) {
                  for (let j = 0; j < this.transactionHistory[i].subsriptionPkg.length; j++) {
                    this.transactionHistory[i].subsriptionPkg[j].currentStatus = response.data.subscriptionStatus;
                  }
                  this.foruscareService.showNotification("Payment status updated", "success");
                }
              }
            }
          }
          else if (this.applicationId == "FH-PAYMENT" && response.data != null && (response.data.paymentStatus.toLowerCase() == 'success' || response.data.paymentStatus.toLowerCase() == 'failure')) {
            for (let i = 0; i < this.transactionHistory.length; i++) {
              if (this.transactionHistory[i].transactionId == paymentRecord.transactionId) {
                this.transactionHistory[i].paymentStatus = response.data.paymentStatus;
                if (this.transactionHistory[i].subsriptionPkg != null && this.transactionHistory[i].subsriptionPkg.length > 0) {
                  for (let j = 0; j < this.transactionHistory[i].subsriptionPkg.length; j++) {
                    this.transactionHistory[i].subsriptionPkg[j].currentStatus = response.data.subscriptionStatus;
                  }
                  this.foruscareService.showNotification("Payment status updated", "success");
                }
              }
            }
          }
          else if (this.applicationId == "EYE_CONNECT" && response.data != null && (response.data.paymentStatus.toLowerCase() == 'success' || response.data.paymentStatus.toLowerCase() == 'failure')) {
            for (let i = 0; i < this.transactionHistory.length; i++) {
              if (this.transactionHistory[i].transactionId == paymentRecord.transactionId) {
                this.transactionHistory[i].paymentStatus = response.data.paymentStatus;
                if (this.transactionHistory[i].subsriptionPkg != null && this.transactionHistory[i].subsriptionPkg.length > 0) {
                  for (let j = 0; j < this.transactionHistory[i].subsriptionPkg.length; j++) {
                    this.transactionHistory[i].subsriptionPkg[j].currentStatus = response.data.subscriptionStatus;
                  }
                  this.foruscareService.showNotification("Payment status updated", "success");
                }
              }
            }
          }
          else if (this.applicationId == "SPECTACLE" && response.data != null && (response.data.transactionStatus.toLowerCase() == 'success' || response.data.transactionStatus.toLowerCase() == 'payment_failed')) {
            for (let i = 0; i < this.transactionHistory.length; i++) {
              if (this.transactionHistory[i].transactionId == paymentRecord.transactionId) {
                if (response.data.transactionStatus == "SUCCESS") {
                  this.transactionHistory[i].paymentStatus = "success";
                }
                else if (response.data.transactionStatus == "PAYMENT_FAILED") {
                  this.transactionHistory[i].paymentStatus = "failure";
                }
                this.foruscareService.showNotification("Payment status updated", "success");
              }
            }
          }
          else if (this.applicationId == "APPOINTMENT_BOOKING" && response.data != null && (response.data.paymentStatus.toLowerCase() == 'success' || response.data.paymentStatus.toLowerCase() == 'failure')) {
            for (let i = 0; i < this.transactionHistory.length; i++) {
              if (this.transactionHistory[i].transactionId == paymentRecord.transactionId) {
                this.transactionHistory[i].paymentStatus = response.data.paymentStatus;
                this.foruscareService.showNotification("Payment status updated", "success");
              }
            }
          }
          else {
            this.foruscareService.showNotification("The payment was not completed by User", "warning");
          }
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }

  showSyncPaymentStatus = function (paymentRecord) {
    let transactionTime = new Date(paymentRecord.paymentTime).getTime();
    let currentTime = new Date().getTime();
    let duration = (currentTime - transactionTime); //in milisec
    duration = duration / 3600000; //in hour
    if (duration > 24) {
      return false;
    }
    else {
      return true;
    }
  }

  getSpectacleVendorProviders() {
    this.paymentService.getSpectacleVendorProviders()
      .subscribe((response: any) => {
        if (response.status == 200) {
          this.spectacleVendorProviders = response.data;
        }
      })
  }

  changeApplication() {
    this.userSearch = null;
    this.resetToAll();
    switch (this.applicationId) {
      case "DHP":
      case "FH-PAYMENT":
        this.accounts = this.allaccounts;
        break;
      case "APPOINTMENT_BOOKING":
        this.accounts = this.allaccounts.filter(function (x) { return x.enableScreeningEvents == true; });
        break;
    }
    this.getTransactionHistory(0);
  }

  resetToAll() {
    $('#all').css("border-bottom", "none");
    $('#success').css("border-bottom", "none");
    $('#failure').css("border-bottom", "none");
    $('#initiated').css("border-bottom", "none");
    $('#refunded').css("border-bottom", "none");
    $('#all').css("border-bottom", "2px solid rgb(53,191,224");
    this.selectedPaymentFilter = "all";
  }
  paginatedTransactions(event: any) {
    let offset = event.first;
    if (this.userSearch && this.userSearch.trim().length > 0) {
      this.filterTransactionByUserName(offset);
    }
    else {
      this.getTransactionHistory(offset);
    }
  }
  getDisplayRole(role: string): string {
    if (!role) return 'NA';
   
    const roleMap = {
      'ROLE_ADMIN': 'Admin',
      'ROLE_SUPER_ADMIN': 'Super Admin',
      'ROLE_ORGANIZATION': 'Operator',
      'ROLE_CLUSTER_LEAD': 'Screening Center Manager',
      'ROLE_HOSPITAL_OPERATOR': 'Hospital Operator',
      'ROLE_PROGRAM_LEAD': 'Account Admin',
      'ROLE_PROGRAM_MANAGER': 'Account Admin',
      'ROLE_OPHTHALMOLOGY_EXPERT': 'Ophthalmology Expert',
      'ROLE_OPTHALMOLOGY_SUPERVISOR': 'Ophthalmology Supervisor',
      'ROLE_TELE_OPTOMETRIST': 'Tele Optometrist',
      'ROLE_TELE_EXPERT': 'Tele Expert',
      'ROLE_EYE_CONNECT': 'Eye Connect',
      'ROLE_EYE_MITRA': 'Eye Mitra',
      'ROLE_EYEMITRA': 'Eye Mitra', // alternative spelling
      'ROLE_QUALITY_AUDITOR': 'Quality Auditor',
      'ROLE_OPERATIONAL_ADMIN': 'Operational Admin',
      'ROLE_SPECTACLE_ADMIN': 'Spectacle Admin',
      'ROLE_SPECTACLE_OPERATOR': 'Spectacle Operator'
    };
   
    return role
      .split(',')
      .map(r => r.trim().toUpperCase())
      .map(r => roleMap[r] || r) // fallback to raw role if not in map
      .filter((value, index, self) => self.indexOf(value) === index) // remove duplicates
      .join(', ');
  }
  
  findValueInJsonArray(array:any,value:string){
    return array.some(obj => Object.values(obj).includes(value));
  }
}


